import agriculture1 from "../images/agriculture photo 1.png";
import agriculture2 from "../images/agriculture photo 2.png";
import agriculture3 from "../images/agriculture photo 3.png";
import contruction1 from "../images/construction labour 1.png";
import construction2 from "../images/construction labour 2.png";
import construction3 from "../images/construction labour 3.png";
import dairy1 from "../images/dairy form photo 1.png";
import dairy2 from "../images/dairy form photo 2.png";
import dairy3 from "../images/dairy form photo 3.png";
import solar1 from "../images/solar panel 1.png";
import solar2 from "../images/solar panel 2.png";
import solar3 from "../images/solar panel 3.png";

export const ServiceList = [
  {
    name: "Construction",
    description:
      "We provide skilled labor for all types of construction projects.",
    images: [contruction1, construction2, construction3],
    details: "From residential buildings to commercial complexes, our experienced workforce ensures high-quality construction services.",
  },
  {
    name: "Solar Panel Installation",
    description:
      "Our team specializes in efficient and reliable solar panel installation.",
    images: [solar1, solar2, solar3],
    details: "Harness the power of the sun with our top-notch solar panel installation services for homes and businesses.",
  },
  {
    name: "Agriculture Work",
    description:
      "Expert labor for agriculture and dairy farming to boost your productivity.",
    images: [agriculture1, agriculture2, agriculture3],
    details: "Our workers are skilled in modern agricultural practices and dairy farming techniques, ensuring healthy produce and livestock.",
  },
  {
    name: "Dairy Farming",
    description:
      "Expert labor for dairy farming to boost your productivity.",
    images: [dairy1, dairy2, dairy3],
    details: "Our workers are skilled in modern dairy farming techniques, ensuring healthy produce and livestock.",
  },
];
